module.exports = __webpack_public_path__ + "media/images/icon-review-cdf16914f66d3764939a52930ddaa661.svg";